import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import notify from 'devextreme/ui/notify';
import * as moment from 'moment';
import { Observable } from 'rxjs';
import { DynamicLayoutService } from '../../../../_api/services/dynamic-layout.service';
import { DateSelectorDateSettingPeriod, DateSelectorDateSettings } from '../../date-selector/date-selector.component';

let self: DynamicSubMenuItemComponent = null;
@Component({
  selector: 'app-dynamic-sub-menu-item',
  templateUrl: './dynamic-sub-menu-item.component.html',
  styleUrls: ['./dynamic-sub-menu-item.component.css']
})
export class DynamicSubMenuItemComponent implements OnInit {

  private _moduleFunctionDynamicSubMenu = null;
  @Input() set moduleFunctionDynamicSubMenu(val ) {
    this._moduleFunctionDynamicSubMenu = val;
    const ds = val.dateSettings as DateSelectorDateSettings;
    this.selectedDate = ds.selectedPeriod.FromDate;
    this.selectedDateRangeIndex = ds.selectedDateRangeIndex;
    this.selectedPeriod = ds.selectedPeriod;
    this.refresh();
  }

  get moduleFunctionDynamicSubMenu() {
    return this._moduleFunctionDynamicSubMenu;
  }

  @Output() dateSettingsChanged = new EventEmitter<DateSelectorDateSettings>();

  data = null;
  selectedDateRangeIndex = 0;
  selectedDate: moment.Moment = null;
  selectedPeriod: DateSelectorDateSettingPeriod = null;

  get dynamicLayoutDataSource(): (dynamicLayoutId: number) => Observable<any> {
    return this._overviewDynamicLayoutDataSource;
  }

  _overviewDynamicLayoutDataSource(dynamicLayoutId: number): Observable<any> {
    let fromDate: moment.Moment = null;
    let toDate: moment.Moment = null;
    if (self._moduleFunctionDynamicSubMenu.ShowDatePeriod) { 
      if (self.selectedPeriod != null) {
        fromDate = self.selectedPeriod.FromDate;
        toDate = self.selectedPeriod.ToDate;
      }
      else {
        fromDate = toDate = moment();
      }
    }
    return self.dynamicLayoutService.GetSubMenuItemData(dynamicLayoutId, fromDate, toDate);
  }

  constructor(private dynamicLayoutService: DynamicLayoutService) {
    self = this;
  }

  ngOnInit(): void {
  }

  selectedDateRangeIndexChanged(index) {
    this.selectedDateRangeIndex = index;
    this.emitDateChanged();
  }

  selectedDateChanged(selectedPeriod: DateSelectorDateSettingPeriod) {
    this.selectedPeriod = selectedPeriod;
    this.selectedDate = selectedPeriod.FromDate;
    this.emitDateChanged();
  }

  emitDateChanged() {
    const dateSettings: DateSelectorDateSettings = new DateSelectorDateSettings();
    dateSettings.selectedPeriod = this.selectedPeriod;
    dateSettings.selectedDateRangeIndex = this.selectedDateRangeIndex;
    this.dateSettingsChanged.emit(dateSettings);
    this.refresh(true);
  }

  refresh(dataSourceOnly: boolean = false) {
    let theData = null;
    this.dynamicLayoutService.GetSubMenuItem(this._moduleFunctionDynamicSubMenu.ModuleFunctionDynamicSubMenuId).toPromise().then((data) => {
      theData = data;
    }).finally(() => {
      this.data = theData;
    }).catch((reason) => {
      notify(reason, "error", 3000);
    });
  }

}

